import type { AccountCloudPosture } from './accountStateMachine.js'

export type OpenFileGuardMode = 'protect-local-space' | 'protect-current-space'

export type ResolveOpenFileGuardInput = {
  hasLocalReplaceRisk: boolean
  hasSyncReplaceRisk: boolean
  hasMountedAccount: boolean
  isSyncPaired: boolean
  cloudPosture: AccountCloudPosture
}

export function resolveOpenFileGuard(input: ResolveOpenFileGuardInput): OpenFileGuardMode | undefined {
  if (!input.hasMountedAccount || !input.isSyncPaired) {
    return input.hasLocalReplaceRisk ? 'protect-local-space' : undefined
  }

  if (input.cloudPosture !== 'connected-verified' && input.hasSyncReplaceRisk) {
    return 'protect-current-space'
  }

  return undefined
}
